export default {
  title: 'Accès restreint',
  message: 'Désolé, vous n\'avez pas accès à cette page.',
  technicalErrorButton: 'Aller à l’accueil',
};
